/**
 * External dependencies
 */
import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

/**
 * Internal dependencies
 */
import { AccountList, Accounts, AccountListCondition, AccountInfo, AccountInfos } from './types';

class Account extends Immerable {
  public accountListDefaultCondition: AccountListCondition;

  public accountList: Accounts;

  public accountInfos: AccountInfos;

  public constructor() {
    super();
    this.accountListDefaultCondition = {
      api: {
        page: 1,
        page_size: 40,
        with_pager: false
      },
      display: {
        keyword: ''
      }
    };
    this.accountList = {
      condition: this.accountListDefaultCondition,
      content: {
        list: [],
        pager: {
          page: 0,
          page_size: 0,
          total_page: 0,
          total_count: 0
        }
      }
    };
    this.accountInfos = {};
  }

  public initialize(): void {
    this.accountListDefaultCondition = {
      api: {
        page: 1,
        page_size: 40,
        with_pager: false
      },
      display: {
        keyword: ''
      }
    };
    this.accountList = {
      condition: this.accountListDefaultCondition,
      content: {
        list: [],
        pager: {
          page: 0,
          page_size: 0,
          total_page: 0,
          total_count: 0
        }
      }
    };
    this.accountInfos = {};
  }

  public updateAccountList(newList: AccountList, newCondition: AccountListCondition): void {
    this.accountList = { content: newList, condition: newCondition };
  }

  public updateAccountInfo(newAccountID: string, newAccount: AccountInfo): void {
    this.accountInfos[newAccountID] = newAccount;
  }
}

export default Account;
